import React from 'react';
import ReactDOM from 'react-dom';
import Nav_path from './Home/Navbar_module/Nav_path';
import { Provider } from '@lyket/react';
import ReactGA from 'react-ga';


ReactGA.initialize('UA-199925732-1'); // add your tracking id here.
ReactGA.pageview(window.location.pathname + window.location.search);
ReactDOM.render(
  <React.StrictMode>
     <Provider apiKey="pt_55b8c1dabddd950e6c8f1d23e65b52"></Provider>
    <Nav_path></Nav_path>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

